/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Board_Hub_TitleInputs */

const en_us2_board_hub_title = /** @type {(inputs: Board_Hub_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Community board`)
};

const pt_br2_board_hub_title = /** @type {(inputs: Board_Hub_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mural da comunidade`)
};

const pt_pt2_board_hub_title = /** @type {(inputs: Board_Hub_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mural da comunidade`)
};

/** @type {(inputs: Board_Hub_TitleInputs) => LocalizedString} */
const es_419_board_hub_title = en_us2_board_hub_title;

/** @type {(inputs: Board_Hub_TitleInputs) => LocalizedString} */
const fr_fr2_board_hub_title = en_us2_board_hub_title;

/** @type {(inputs: Board_Hub_TitleInputs) => LocalizedString} */
const de_de2_board_hub_title = en_us2_board_hub_title;

/** @type {(inputs: Board_Hub_TitleInputs) => LocalizedString} */
const it_it2_board_hub_title = en_us2_board_hub_title;

/**
* | output |
* | --- |
* | "Community board" |
*
* @param {Board_Hub_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const board_hub_title = /** @type {((inputs?: Board_Hub_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Board_Hub_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_board_hub_title(inputs)
	if (locale === "es-419") return es_419_board_hub_title(inputs)
	if (locale === "pt-PT") return pt_pt2_board_hub_title(inputs)
	if (locale === "fr-FR") return fr_fr2_board_hub_title(inputs)
	if (locale === "de-DE") return de_de2_board_hub_title(inputs)
	if (locale === "it-IT") return it_it2_board_hub_title(inputs)
	return en_us2_board_hub_title(inputs)
});
export { board_hub_title as "board.hub_title" }